<template>
  <button
    id="lighting-button"
    ref="lightingButton"
    class="cesium-button cesium-toolbar-button"
    @click="toggleLighting"
    title="Toggle Earth's shadow"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        id="moon-icon"
        fill="#FFFFFF"
        fill-opacity="0"
        stroke="#FFFFFF"
        d="M17.39 15.14A7.33 7.33 0 0 1 11.75 1.6c.23-.11.56-.23.79-.34a8.19 8.19 0 0 0-5.41.45 9 9 0 1 0 7 16.58 8.42 8.42 0 0 0 4.29-3.84 5.3 5.3 0 0 1-1.03.69z"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'cesium-lighting-button',

  props: ['viewer'],

  computed: {
    cesiumViewer() {
      return this.viewer ? this.viewer : this.$parent.viewer
    }
  },

  methods: {
    toggleLighting() {
      // toggles globe lighting
      this.cesiumViewer.scene.globe.enableLighting =
        !this.cesiumViewer.scene.globe.enableLighting

      // modifies the moon icon depending on lighting
      const path = document.getElementById('moon-icon')
      if (!this.cesiumViewer.scene.globe.enableLighting) {
        path.setAttribute('fill-opacity', '0.0')
        path.setAttribute('stroke', '#FFFFFF')
      } else {
        path.setAttribute('stroke', 'transparent')
        path.setAttribute('fill-opacity', '1.0')
      }
    }
  }
}
</script>

<style>
#lighting-button {
  position: relative;
  padding: 0;
}

#lighting-button svg {
  position: absolute;
  width: 80%;
  height: 80%;
  top: 10%;
  left: 14%;
}
</style>
